import { ExternalLink } from "lucide-react";
import { mapsUrl } from "../lib/mapsLink";

// Wraps a place name so it opens in Google Maps. Renders children unchanged when
// the place has neither an id, coordinates, nor a name — a link that goes nowhere
// is worse than plain text.
export function MapLink({ place, className = "", title = "Buka di Google Maps", children, icon = true }) {
  const href = mapsUrl(place);
  if (!href) return children;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      onClick={(e) => e.stopPropagation()}
      className={`group/maps inline-flex items-baseline gap-1 hover:underline decoration-dotted underline-offset-2 ${className}`}
    >
      {children}
      {icon && (
        <ExternalLink className="w-2.5 h-2.5 shrink-0 self-center opacity-0 group-hover/maps:opacity-60 transition-opacity" />
      )}
    </a>
  );
}
